import React from 'react';

const DetailModuleManagementJobFamilyPage = () => {
  return <div>DetailModuleManagementJobFamilyPage</div>;
};

export default DetailModuleManagementJobFamilyPage;
